import { LocalStorageService } from '../../../core/services/local-storage.service';
import { StatService } from '../../../core/services/stat-service/stat.service';
import { Component, ViewChild } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexXAxis,
  ApexPlotOptions,
  ApexNonAxisChartSeries,
} from 'ng-apexcharts';

export type ChartOptions = {
  series: ApexAxisChartSeries | ApexNonAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
};
@Component({
  selector: 'app-dashboardclient',
  templateUrl: './dashboardclient.component.html',
  styleUrls: ['./dashboardclient.component.css'],
})
export class DashboardclientComponent {
  /* ********************************** apexChart ********************************* */
  @ViewChild('chart') chart!: ChartComponent;
  public chartOptions!: any;
  id: any;
  liststat: any;
  constructor(
    private statservice: StatService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit() {
    this.chartOptions = {
      series: [
        {
          name: 'basic',
          data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380],
        },
      ],
      chart: {
        type: 'bar',
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [
          'South Korea',
          'Canada',
          'United Kingdom',
          'Netherlands',
          'Italy',
          'France',
          'Japan',
          'United States',
          'China',
          'Germany',
        ],
      },
    };

    this.getStat();
  }

  getStat() {
    this.id = this.localStorageService.getData('clientConnected');
    this.statservice.getStat(this.id).subscribe({
      next: (response) => {
        if (response.data) {
          this.liststat = response.data;
        }
      },
      error: (error) => {},
    });
  }
}
